(function($){
	$(document).ready(function(){
		// var openRegion;

		var MapView = Backbone.View.extend({
			events: {
				'click svg g': 'openRegion',
				'click a.info-close' : 'closeRegion'
			},
			initialize: function(){
				_.bindAll( this, 'render', 'openRegion', 'closeRegion', '_closeRegion', 'renderMap', 'renderDropdown', 'addRegionDropdown', 'setRegions' );
				this.selectedRegion = false;
				this.template = _.template( $( '#region-info-window-template' ).html() );
				this.dropdownItemTemplate = _.template( '<li class="dropdown-list-item"><a href="<%= link %>"><%= name %></a></li>')
			},
			render: function(){
				this.renderDropdown();
				this.renderMap();
			},
			renderDropdown: function(){
				if ( typeof this.regions !== 'undefined' ) {
					_.each( this.regions, this.addRegionDropdown );
				}
			},
			addRegionDropdown: function( x ){
				var link = this.dropdownItemTemplate( x );
				this.$('#map-region-menu').append( link );
			},
			renderMap: function(){
				if ( $(window).width() > 767 ) {
					fetch( site_data.template_directory_url + '/images/where-we-work-map.svg?v=2')
					.then(response => response.text())
					.then(svgContent => {
						this.$('.map-holder').html( svgContent );
					});
				} else {
					this.$('.map-holder').html( '<img src="'+site_data.template_directory_url + '/images/mobile-map.png" class="img-fluid" />' );
				}
			},
			openRegion: function( e ){
				e.preventDefault();
				var positions = {
					'africa' : { left: '40%', top: '40%', right: true },
					'latin-america' : { left: '40%', top: '50%', right: false },
					'south-asia' : { left: '60%', top: '33.333%', right: true },
					'southeast-asia' : { left: '70%', top:'40%', right: true },
					'united-states' : { left: '30%', top: '25%', right: false }
				};

				var region = e.currentTarget.dataset.region;

				var regionObject = typeof this.regions[region] !== 'undefined' ? this.regions[region] : false;

				var regionEl = e.currentTarget;
				var regionPos = positions[region];

				var infoLeft = regionPos.left;
				var infoTop = regionPos.top;

				var mapInfoWindow = this.$('.map-info-window');
				this._closeRegion();

				if ( regionPos.right ) {
					mapInfoWindow.addClass( 'right' );
				} else {
					mapInfoWindow.removeClass( 'right' );
				}
				this.$el.addClass( 'region-selected' );

				mapInfoWindow.addClass( 'show' );
				mapInfoWindow.css({ left: infoLeft, top: infoTop });
				var region_html;
				if ( regionObject ) {
					region_html = this.template( regionObject );

				} else {
					region_html = '<p>Region Not Found</p>';
				 }
				mapInfoWindow.find('.info-content').html( region_html );



				regionEl.classList.add( 'active' );
				this.selectedRegion = regionEl;

			},
			closeRegion: function( e ){
				e.preventDefault();
				this._closeRegion();
				
			},
			_closeRegion: function() {
				if ( this.selectedRegion ) {
					this.$el.removeClass( 'region-selected' );
					this.selectedRegion.classList.remove( 'active' );
					this.selectedRegion = false;

					var mapInfoWindow = this.$('.map-info-window');
					mapInfoWindow.removeClass( 'show' );
				}
			},
			setRegions: function( regions ){
				this.regions = regions;
			}
		});

		var mapWrap = $( '.map-wrap' );

		var mapApp = new MapView({el: mapWrap});
		mapApp.setRegions( window.regionCollection );
		mapApp.render();


		
		
	})
})(jQuery);
// import './region-menu';